import {
  drybulkCargoOperationsService,
  type ToleranceUpdateRequest,
} from "@services/drybulkCargoOperationsApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";
import { DRYBULK_CARGO_OPS_QUERY_KEYS } from "../constants";
import { closeOutContext } from "./closeOutTransaction";

export const useToleranceMutation = (operationId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (request: ToleranceUpdateRequest) =>
      runTransaction(closeOutContext("edit_tolerance", operationId), (transactionId) =>
        drybulkCargoOperationsService.editTolerance(operationId, request, { transactionId }),
      ),
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({
          queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.detail(operationId),
        }),
        queryClient.invalidateQueries({
          queryKey: DRYBULK_CARGO_OPS_QUERY_KEYS.toleranceChanges(operationId),
        }),
      ]),
  });
};
